import { useEffect, useState } from "react";
import { Col, Row } from "antd";
import { FormBox, InputBox } from "../../../../../components/AntdAddons";
import PlaceAutoCompleteInput from "../../../../../components/FormFields/PlaceAutoCompleteInput";
import SingleMarkerMap from "../../../../../components/Map/SingleMarkerMap";
import { locationOptions } from "../../utils/constant";
import { rules } from "./rules";

/**
 * Renders a form component for adding or editing a VR training location record.
 *
 * @param {Object} props - The component props.
 * @param {Object} props.form - The form object from the antd form library.
 * @param {string} props.id - The ID of the form.
 * @param {Function} props.handleSubmit - The function to handle form submission.
 * @param {Function} props.onValuesChange - The function to handle form value changes.
 * @param {Object} props.editValues - The values to pre-populate the form with.
 * @return {JSX.Element} The rendered form component.
 */
const FormComponent: React.FC<any> = ({
  form,
  id,
  handleSubmit,
  onValuesChange,
  editValues,
}) => {
  useEffect(() => {
    if (editValues) {
      form.setFieldsValue({
        ...editValues,
        type: locationOptions.find((data) => data.name === editValues.type)?.id,
      });
    }
  }, [editValues, form]);

  const onFinish = (data: any) => {
    data.latitude = latLng?.lat;
    data.longitude = latLng?.lng;

    handleSubmit(data);
  };

  const [latLng, setLatLng] = useState<{ lat: number; lng: number }>({
    lat: Number(editValues?.latitude),
    lng: Number(editValues?.longitude),
  });

  return (
    <>
      <FormBox
        form={form}
        id={id}
        onFinish={onFinish}
        onValuesChange={onValuesChange}
      >
        <Row gutter={15}>
          <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.Text
              required
              label="Name"
              name={"name"}
              rules={rules.name()}
            />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <PlaceAutoCompleteInput
              required
              className="singleSelect"
              label="Location"
              name={"vr_training_location"}
              setLatLng={setLatLng}
            />
            <Col xs={{ span: 24 }} md={{ span: 24 }}>
              <InputBox.Radio
                required
                label="Type"
                options={{
                  list: locationOptions,
                  valueKey: "id",
                  textKey: "name",
                }}
              />
            </Col>
            <Col xs={{ span: 24 }} md={{ span: 24 }}>
              <Col xs={{ span: 24 }} md={{ span: 24 }}>
                <InputBox.TextArea name="description" label="Description" />
              </Col>
            </Col>
            <br />
            <SingleMarkerMap
              key={latLng?.lat}
              {...(latLng?.lat ? { latitudeVal: latLng?.lat } : {})}
              {...(latLng?.lng ? { longitudeVal: latLng?.lng } : {})}
            />
          </Col>
        </Row>
      </FormBox>
    </>
  );
};

export default FormComponent;
